"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const colors_1 = __importDefault(require("../../styles/colors"));
const styles_1 = __importDefault(require("../../styles/styles"));
const boxTitle_1 = __importDefault(require("../boxTitle/boxTitle"));
const icon_1 = __importDefault(require("../icon/icon"));
const historyBoxStyles_1 = __importDefault(require("./historyBoxStyles"));
const constants_1 = require("../../constants/constants");
const actionHistoryTable_1 = __importDefault(require("./actionHistoryTable/actionHistoryTable"));
const HistoryBox = ({ currentStage, previousStages, nextStages, actions, }) => {
    const previousStagesWithStyle = [
        {
            stageName: 'APPROVED',
            style: historyBoxStyles_1.default.previousStage,
            icon: free_solid_svg_icons_1.faCheck,
            iconColor: colors_1.default.BLUE,
            textColor: styles_1.default.textColorBlue,
        },
    ].concat(previousStages.map((stageName) => {
        return {
            stageName,
            style: historyBoxStyles_1.default.previousStage,
            icon: free_solid_svg_icons_1.faCheck,
            iconColor: colors_1.default.BLUE,
            textColor: styles_1.default.textColorBlue,
        };
    }));
    const nextStagesWithStyle = nextStages
        .map((stageName) => ({
        stageName,
        style: historyBoxStyles_1.default.nextStage,
        icon: free_solid_svg_icons_1.faLock,
        iconColor: colors_1.default.GRAY_3,
        textColor: styles_1.default.textColorGray,
    }))
        .concat([
        {
            stageName: 'PAID',
            style: historyBoxStyles_1.default.nextStage,
            icon: free_solid_svg_icons_1.faLock,
            iconColor: colors_1.default.GRAY_3,
            textColor: styles_1.default.textColorGray,
        },
    ]);
    const allStagesOrdered = previousStagesWithStyle.concat([
        {
            stageName: currentStage,
            style: historyBoxStyles_1.default.currentStage,
            icon: free_solid_svg_icons_1.faFlag,
            iconColor: colors_1.default.WHITE,
            textColor: styles_1.default.textColorWhite,
        },
    ], nextStagesWithStyle);
    return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.boxStyles },
        react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.marginTen, { zIndex: 10 }] },
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.alignCenterStart },
                react_1.default.createElement(boxTitle_1.default, { title: "History" }))),
        react_1.default.createElement(react_native_1.ScrollView, { horizontal: true, showsHorizontalScrollIndicator: false, contentContainerStyle: react_native_1.Platform.OS === constants_1.WEB_TAG ? styles_1.default.contentContainerStyle : null },
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.marginTen] }, allStagesOrdered.map((stage, index) => (
            // no unique attribute for key
            react_1.default.createElement(react_native_paper_1.Chip
            // eslint-disable-next-line react/no-array-index-key
            , { 
                // eslint-disable-next-line react/no-array-index-key
                key: index, style: [stage.style, styles_1.default.marginRightTen], avatar: react_1.default.createElement(icon_1.default, { icon: stage.icon, color: stage.iconColor }), textStyle: [stage.textColor, styles_1.default.fontSizeText] }, stage.stageName))))),
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTen },
            react_1.default.createElement(actionHistoryTable_1.default, { historyActions: actions }))));
};
exports.default = HistoryBox;
